import { Contract, ethers, Signer } from "ethers";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../hooks";
import ABI from "./marketplace.json";
import { getSecrets } from "../../config";

interface IMarketplaceContext {
  contract: Contract | undefined;
  signer: Signer | undefined;
  currencyList: any | undefined;
  chainId: number | undefined;
}

export const marketplaceContext = React.createContext<IMarketplaceContext>({
  contract: undefined,
  signer: undefined,
  currencyList: undefined,
  chainId: undefined,
});

interface IProps {
  children: React.ReactNode;
}

export const MarketplaceProvider = ({ children }: IProps) => {
  const [contract, setContract] = useState<Contract>();
  const [signer, setSigner] = useState<Signer>();
  const [chainId, setChainId] = useState();
  const [currencyList, setCurrencyList] = useState({
    MARKET_CONTRACT: "",
    DELEGATE_CONTRACT: "",
    ETH_CONTRACT: "",
    USDC_CONTRACT: "",
    USDT_CONTRACT: "",
    MATIC_CONTRACT: ""
  });
  const { currentAddress } = useAppSelector((state) => state.auth);
  const {
    MARKET_CONTRACT,
    DELEGATE_CONTRACT,
    ETH_CONTRACT,
    USDC_CONTRACT,
    USDT_CONTRACT,
    MARKET_CONTRACT_MATIC,
    DELEGATE_CONTRACT_MATIC,
    MATIC_CONTRACT,
    ETH_CONTRACT_MATIC,
    USDC_CONTRACT_MATIC,
    USDT_CONTRACT_MATIC,
  } = getSecrets();

  const checkIfChainIdChanged = async () => {
    try {
      window.ethereum.on("chainChanged", (chainId: any) => {
        console.log("ChainId changed to:", chainId);
        setChainId(chainId);
      });
    } catch (error) {
    }
  };
  useEffect(() => {
    checkIfChainIdChanged();
  }, [window.ethereum]);
  useEffect(() => {
    if (!currentAddress) return;
    //@ts-ignore
    if (typeof window.ethereum !== "undefined") {
      //@ts-ignore
      try {
        setChainId(window.ethereum.networkVersion);
        if (
          window.ethereum.networkVersion == 1 ||
          window.ethereum.networkVersion == 5
        ) {
          setCurrencyList({
            MARKET_CONTRACT: MARKET_CONTRACT,
            DELEGATE_CONTRACT: DELEGATE_CONTRACT,
            ETH_CONTRACT: ETH_CONTRACT,
            USDC_CONTRACT: USDC_CONTRACT,
            USDT_CONTRACT: USDT_CONTRACT,
            MATIC_CONTRACT: ""
          });
        } else if (
          window.ethereum.networkVersion == 137
        ) {
          setCurrencyList({
            MARKET_CONTRACT: MARKET_CONTRACT_MATIC,
            DELEGATE_CONTRACT: DELEGATE_CONTRACT_MATIC,
            ETH_CONTRACT: ETH_CONTRACT_MATIC,
            USDC_CONTRACT: USDC_CONTRACT_MATIC,
            USDT_CONTRACT: USDT_CONTRACT_MATIC,
            MATIC_CONTRACT: MATIC_CONTRACT
          });
        }
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const contractAddress = currencyList.MARKET_CONTRACT;
        const signerInfo = provider.getSigner();
        setSigner(signerInfo);
        setContract(
          new ethers.Contract(contractAddress, JSON.stringify(ABI), signerInfo)
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, [currentAddress, chainId]);

  return (
    <marketplaceContext.Provider value={{ contract, signer, currencyList, chainId }}>
      {children}
    </marketplaceContext.Provider>
  );
};
